export default __webpack_public_path__ + "static/media/error-img.6fcac550.svg";